import { Table } from "reactstrap";
import { P } from "../../../../AbstractElements";
import {Date, DueAmount, InvoiceNo } from "../../../../utils/Constant";
import { useTranslation } from "react-i18next";


const InvoiceNumber = ({data}:any) => {
  const {t}=useTranslation()
  return (
    <td>
      <Table borderless style={{ width: "100%", borderSpacing: 4 }} >
        <tbody>
          <tr className="back">
            <td style={{ background: "#F5F6F9", padding: "15px 25px" }} >
              <P style={{ fontSize: 16, fontWeight: 500, opacity: "0.8", margin: 0, lineHeight: 2 }} >
                {Date} :
              </P>
              <span style={{ fontSize: 16, fontWeight: 600 }}>
               {data?.date}
              </span>
            </td>
            <td style={{ background: "#F5F6F9", padding: "15px 25px" }} >
              <P style={{ fontSize: 16, fontWeight: 500, opacity: "0.8", margin: 0, lineHeight: 2 }} >
                {InvoiceNo} :
              </P>
              <span style={{ fontSize: 16, fontWeight: 600 }}>#VL25000365</span>
            </td>
            <td style={{ background: "#F5F6F9", padding: "15px 25px"}}>
              <P style={{ fontSize: 16, fontWeight: 500, opacity: "0.8", margin: 0, lineHeight: 2}}>
                {t("DueDate")} :
              </P>
              <span style={{ fontSize: 16, fontWeight: 600 }}>
               {data?.duedate}
              </span>
            </td>
            <td style={{ background: "#F5F6F9", padding: "15px 25px" }} >
              <P style={{ fontSize: 16, fontWeight: 500, opacity: "0.8", margin: 0, lineHeight: 2 }} >
                {DueAmount} :
              </P>
              <span style={{ fontSize: 16, fontWeight: 600 }}>$7860.00 </span>
            </td>
          </tr>
        </tbody>
      </Table>
    </td>
  );
};

export default InvoiceNumber;
